import { TermPolicyStatusResponse } from '@store/term-status/types';

import { client } from '../client';
import { CountryResponse, TermCompaniesResponse } from '../types';

import { termEndPoints } from './endpoints';

export const getTermStatus = (policyId: string): Promise<TermPolicyStatusResponse> =>
  client.get(termEndPoints.status(policyId));

export const getCountries = (): Promise<CountryResponse> =>
  client.get(termEndPoints.countries, { detailed: true });

export const getCompanies = (
  insurerSlug: string,
  search: string
): Promise<TermCompaniesResponse> => {
  return client.get(termEndPoints.companies, { search, insurer: insurerSlug });
};
